import React from 'react'
import SettingsTasksForm from '../components/setting/settingsTasksForm'

const SettingsTasks = () => {
    return (
        <>
            <SettingsTasksForm />
        </>
    )
}

export default SettingsTasks